import { render, staticRenderFns } from "./StudentLibraryPage.vue?vue&type=template&id=465f67cd&scoped=true"
import script from "./StudentLibraryPage.vue?vue&type=script&lang=js"
export * from "./StudentLibraryPage.vue?vue&type=script&lang=js"
import style0 from "./StudentLibraryPage.vue?vue&type=style&index=0&id=465f67cd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465f67cd",
  null
  
)

export default component.exports